$(function () {
    $('.testimonials-container').slick({
        infinite: true,
        slidesToShow: 3,
        prevArrow: $('.prev'),
        nextArrow: $('.next'),
        dots: true,
        variableWidth: true,
        centerMode: true,
        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                }
            }
        ]
    });
    $(window).on('resize', function () {
        var viewportWidth = $(window).width();
        if (viewportWidth > 575) {
            $('.logo-container').slick('unslick');
        } else {
            $('.logo-container').slick({
                slidesToShow: 2,
                infinite: true,
                slidesToScroll: 2,
                dots: true,
                variableWidth: true,
                arrows: false,
                centerMode: true
            })
        }
    });

    window.onscroll = function () {
        myFunction()
    };
    var header = document.querySelector('.header-bottom');
    var sticky = header.offsetTop;

    function myFunction() {
        if (window.pageYOffset > sticky) {
            header.classList.add("sticky");
        } else {
            header.classList.remove("sticky");
        }
    }

    var popup = new Popup();
    var isshow = localStorage.getItem('isshow');
    if (isshow == null) {
        localStorage.setItem('isshow', 1);
        popup.openPopup();
    }
    popup.closePopup();

    $(document).on('click', '.product-card__variant .product-card__variant--item label', function() {
        var self = $(this),
            $product = self.parents('.product-item'),
            $variantImage = self.data('image');
        $product.find('.product-card__variant--item label').removeClass('active');
        $product.find('#variant').val(self.attr('data-id'));
        if ($variantImage != '') {
            $product.find('.product-item__img').attr('srcset', $variantImage);
        }
        self.addClass('active');
    });
})

var Popup = function () {
    this.closeButton = $('.modal .close_button');
    this.modal = $('.modal');
    this.modalContent = $('.modal__dialog');
    this.close = $('.modal .close_button');
    this.delay = parseInt($('.modal__dialog').attr('data-delay'));
    this.expire = parseInt($('.modal__dialog').data('expire'));
    if (!this.modal.length) {
        return;
    }
};


Popup.prototype.closePopup = function () {
    var self = this;
    this.close.on('click', function (event) {
        event.preventDefault();
        self.modal.removeClass('active');
        // $.cookie('newsLetterPopup', 'closed', {expires: self.expire, path: '/'});
    });

    this.modal.on('click', function (event) {
        if ((self.modal.hasClass('active')) && ($(event.target).closest(self.modalContent).length === 0)){
            event.preventDefault();
            self.modal.removeClass('active');
        }
    });
}

Popup.prototype.openPopup = function () {
    let self = this;
    if (window.location.href.indexOf('newsletter&form_type=customer') > -1) {
        $('.modal .newsletter__error').show();
    } else {
        $('.modal .newsletter__error').hide();
    }

    setTimeout(function () {
        self.modal.addClass('active');
    }, self.delay);
}